module.exports = __webpack_public_path__ + "img/1.9ee0f98a.png";